import React, { useEffect } from 'react';
import './pb2024.css';
import { pb2024 } from '../../json/pb2024';

const Pb2024 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Padrones de Beneficiarios 2024</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
             
              <div style={{ textAlign: 'left' }}>

              <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Subsecretaría de Inclusión y Desarrollo</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx//ENTIDADES/SEBISO/transparencia/pdfs/padrones/2024/Padron_SSID_BYD_1erT.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx//ENTIDADES/SEBISO/transparencia/pdfs/padrones/2024/Padron_SSID_BYD_BMS_3erT.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>

                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Subsecretaría de Desarrollo Social y Humano</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx//ENTIDADES/SEBISO/transparencia/pdfs/padrones/2024/Padron_SSDSyH_1erT_2024.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx//ENTIDADES/SEBISO/transparencia/pdfs/padrones/2024/Padron_SSDSyH_4toT_2024.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx//ENTIDADES/SEBISO/transparencia/pdfs/padrones/2024/PUB_ByP_4t_2024.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Programa Desarrollo Inclusivo Cuarto Trimestre 2024
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>

                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Subsecretaría de Participación Social y Fomento Artesanal</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx//ENTIDADES/SEBISO/transparencia/pdfs/padrones/2024/Padron_de_Beneficiarios_SPSFA.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>

                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Dirección General de Atención al Migrante</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2024/Padron_DGAM_1erT_2024.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2024/Padron_DGAM_2doT_2024.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>

                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2024/Padron_DGAM_3erT_2024-1.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2024/Padron_DGAM_4oT_2024.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>

                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Dirección General de Fomento Artesanal</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2024/Padron_DGFA_1erT_2024.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2024/Padron_DGFA_2doT_2024.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2024/Padron_DGFA_3erT_2024.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2024/Padron_DGFA_4oT_2024.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>
                <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/estadisticas/4oT/Estadisticas_PUB_4to_Trimestre_2024.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Estadisticas PUB 4to Trimestre 2024</h5>
                </a>
                {/* Añade el resto de los bloques aquí */}
              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Pb2024;
